import _ from 'lodash';
import {ServiceStatus} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

import {PageService, Block, PageData, BlockType, HeaderBlock} from 'units/constructor-local/models';
import {canRenderCalculator} from 'units/constructor-local/blocks/Calculator/Calculator';
import {hasDemo} from '../blocks/ServiceDemo/ServiceDemo';
import {MenuItem} from 'units/constructor-local/components/Menu/Menu';
import {ConstructorBlock, getBlockKey} from '@yandex-data-ui/page-constructor';

export const ACCESS_PREVIEW_STATUSES = [ServiceStatus.PublicPreview, ServiceStatus.TechPreview];

export const PREVIEW_STATUSES = [...ACCESS_PREVIEW_STATUSES, ServiceStatus.FreePreview];

export const DESKTOP_ONLY_BLOCKS = [BlockType.CalculatorBlock, BlockType.ServiceDemoBlock];

export function isInterconnect(slug: string) {
    return slug === 'interconnect';
}

export function isServiceNeedAccess({slug, status}: PageService) {
    return ACCESS_PREVIEW_STATUSES.includes(status) || isInterconnect(slug);
}

export const shouldRenderBlock = (
    block: ConstructorBlock,
    service: PageData['service'],
    blockKey: string,
    loadableState: Record<string, boolean>,
) => {
    switch (block.type) {
        case BlockType.CalculatorBlock:
            return canRenderCalculator(service);
        case BlockType.ServiceDemoBlock:
            return hasDemo(service);
        default:
            if ('loadable' in block && block.loadable) {
                return !(blockKey in loadableState) || loadableState[blockKey];
            }

            return true;
    }
};

export const getPageMenuItems = _.memoize(
    (
        service: PageData['service'],
        blocks: ConstructorBlock[],
        loadableState: Record<string, boolean>,
    ) => {
        const items: MenuItem[] = [];

        function getItems(block: ConstructorBlock, index: number) {
            const blockKey = getBlockKey(block, index);
            if (!shouldRenderBlock(block, service, blockKey, loadableState)) {
                return;
            }

            if ('children' in block && block.children && Array.isArray(block.children)) {
                block.children.forEach(getItems);
            }

            //string anchor is used only in old blocks and deprecated
            if ('anchor' in block && block.anchor && typeof block.anchor === 'object') {
                items.push({
                    ...block.anchor,
                    desktopOnly: isDesktopOnly(block.type as BlockType),
                } as MenuItem);
            }
        }

        blocks.forEach(getItems);

        return items;
    },
    (...args) => JSON.stringify(args),
);

export function isDesktopOnly(type: BlockType) {
    return DESKTOP_ONLY_BLOCKS.includes(type);
}

export function getHeaderBlock(blocks: Block[]) {
    return blocks?.find((block): block is HeaderBlock => block.type === BlockType.HeaderBlock);
}
